import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useApplication } from 'merchant-api/unified';
import { useDetailedOffers } from 'merchant-api/offer';
import { checkout } from '..';
import { CheckoutData, RawCheckoutData } from 'merchant-api/types';
import { queryClient } from 'merchant-api';

export interface StartCheckoutProps {
  applicationUuid: string;
  channel: string;
  product: string;
  region: string;
  offerUuid: string;
}

export interface SessionProps {
  starting: boolean;
  start: () => Promise<any>;
  error: Error | null;
  data?: CheckoutData;
  mutation: UseMutationResult<any, Error, void>;
}

export function startCheckout(): SessionProps {
  const { selectedOffer } = useDetailedOffers();
  const { applicationData } = useApplication(['APPROVED']);

  const mutation = useMutation({
    mutationFn: async () => {
      if (!selectedOffer) throw new Error('No selected offer');
      if (!applicationData) throw new Error('No application data');

      const req: StartCheckoutProps = {
        channel: 'DIRECT',
        product: 'TermLoan',
        region: 'US',
        applicationUuid: applicationData.id!,
        offerUuid: selectedOffer.offerId,
      };
      return checkout.post<RawCheckoutData>('/v1/orchestration/start', req)
        .then(res => {
          const data = {
            ...res.data?.data,
          }
          queryClient.setQueryData(['checkout'], data);
          return data;
        });
    }
  });

  return {
    data: mutation.data,
    starting: mutation.isPending,
    error: mutation.error,
    start: mutation.mutateAsync,
    mutation,
  };
}

export default startCheckout;
